module.exports = __webpack_public_path__ + "static/media/14.f4044719.jpeg";